import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { twMerge } from "tailwind-merge";

const SidebarLink = ({
  icon: Icon,
  label,
  link,
  onClose,
  renderRight,
  isActive = false,
}: {
  icon: React.ElementType;
  label: string;
  link: string;
  onClose: () => void;
  renderRight?: React.ReactNode;
  isActive?: boolean;
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Check if this link is the current page
  const isCurrentPage = location.pathname === link || isActive;

  const handleClick = () => {
    navigate(link);
    onClose?.();
  };

  return (
    <button
      onClick={handleClick}
      className={twMerge(
        "group mb-1 flex w-full items-center justify-between px-3 py-2.5 rounded-lg transition-all duration-200 font-medium text-sm",
        isCurrentPage
          ? "bg-primary text-white shadow-md"
          : "text-gray-700 hover:bg-gray-100"
      )}
    >
      <span className="flex items-center gap-3 flex-1 min-w-0">
        <Icon size={18} className={twMerge("flex-shrink-0", isCurrentPage ? "text-white" : "text-primary")} />
        <span className="break-words text-left">{label}</span>
      </span>
      {renderRight && (
        <span className="ml-2 flex-shrink-0">
          {renderRight}
        </span>
      )}
    </button>
  );
};

export default SidebarLink;